import React, { useEffect } from 'react';
import '../About/About.scss';
import './AboutEn.scss';
import phoneIcon from './icons/phone.png';
import mailIcon from './icons/mail.png';
import HanMu from './images/hanmu.png';
import LiShuangfu from './images/lishuangfu.png';
import HanMu_m from './images/hanmu_m.png';
import LiShuangfu_m from './images/lishuangfu_m.png';

import { lanxiongDescEn } from './doc';
import { setWechatShare } from '../../utils';

interface Props {
  getPath: (path: string) => void;
}

const AboutEn: React.FC<Props> = props => {
  useEffect(() => {
    const title = 'About-Lanxiong Sports';
    props.getPath('/en');
    document.title = title;

    setWechatShare({
      title,
    });
  }, [props]);
  return (
    <div className="About About-en">
      <section className="banner">
        CONNECTING TOP RESOURCES <br /> IN SPORTS INDUSTRY
      </section>
      <article className="article">
        <pre>{lanxiongDescEn}</pre>
      </article>
      <section className="founding-team">
        <h2 className="founding-team-title section-title">Management</h2>
        <ul className="content">
          <li>
            <img src={HanMu} alt="Han Mu" />
            <img src={HanMu_m} className="m" alt="" />
          </li>
          <li>
            <img src={LiShuangfu} alt="Li Shuangfu" />
            <img src={LiShuangfu_m} className="m" alt="" />
          </li>
        </ul>
      </section>
      <section className="contact">
        <header>
          <h3>Contact</h3>
        </header>
        <ul className="contact-list">
          <li>
            <img src={phoneIcon} alt="" />
            <p>Phone: +8610-87945186</p>
          </li>
          <li>
            <img src={mailIcon} alt="" />
            <p>Email: zx@lanxiongsports.com</p>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default AboutEn;
